import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component
 * 
 * Automatically scrolls the window to the top when the route pathname changes.
 * This ensures users start at the top of the page when navigating between routes.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Immediate scroll to top without animation for snappy feel on route change
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

